import styled from 'styled-components/macro';

const VideoDescription = styled.div`
  display: block;
  margin-top: 16px;
  width: 100%;
  outline: none;
  resize: none;
  font-size: 16px;
  color: #fff;
`;

export default VideoDescription;
